const GEOLOCATION_API = 'https://www.googleapis.com/geolocation/v1/geolocate';
const GEOCODE_API = `${process.env.NEXT_PUBLIC_SITE_URL}/en/api/geocode/`;
export const locationFetcher = async (lat?: number, lng?: number, key?: string) => {
  let finalLat = lat;
  let finalLng = lng;

  const res = await fetch(`${GEOLOCATION_API}?key=${key}`, {
    method: 'POST',
  });

  if (res.ok) {
    const data = await res.json();
    finalLat = data?.location?.lat;
    finalLng = data?.location?.lng;
  }

  if (finalLat == null || finalLng == null) {
    throw new Error('Unable to fetch coordinates');
  }

  let state: string = 'Draper';
  let stateCode: string | null = 'UT';
  let country: string | undefined;
  let cityName: string = '';

  const geocodeRes = await fetch(GEOCODE_API, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ lat: finalLat, lng: finalLng }),
  });

  if (!geocodeRes.ok) {
    throw new Error('Failed to fetch geocode');
  }

  const data = await geocodeRes.json();

  // If you returned full Google response → use data.results
  const results = data.results || data;

  for (const result of results || []) {
    const comp = result.address_components?.find((c: any) => c.types.includes('administrative_area_level_1'));
    const city = result.address_components?.find((c: any) => c.types.includes('locality'));
    const countryName = result.address_components?.find((c: any) => c.types.includes('country'));

    if (comp && city) {
      cityName = city?.long_name;
      state = comp?.long_name;
      stateCode = comp?.short_name;
      country = countryName?.long_name;
      break;
    }
  }

  return {
    lat: finalLat,
    lng: finalLng,
    state,
    stateCode,
    country,
    cityName,
  };
};
